// src/v2/pages/Reports/EmployeeContributionHistory.js
import React from 'react';
import { GeneralMessage } from '../../../common/APICommon';
import { useEmployeeContributionHistory } from '../../hooks/useEmployeeContributionHistory';
import { EmployeeContributionHistoryModule } from '../../components/modules/Reports/EmployeeContributionHistory/EmployeeContributionHistoryModule';

const EmployeeContributionHistory = ({ isHideSideMenu }) => {
  const reportHook = useEmployeeContributionHistory();

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace"></div>
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <EmployeeContributionHistoryModule reportHook={reportHook} />
      </div>
      <GeneralMessage form={reportHook.showMessage} message={reportHook.message} isSuccess={reportHook.isSuccess} />
    </div>
  );
};

export default EmployeeContributionHistory;